import { ChainId, NATIVE_ADDRESS, NATIVE_SUI, WRAPPED_SOL, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
import { WrappedNativeTokens } from '@shared/types/quoting-engine/wrappedNativeTokens';
import { transformAddress } from '@/lib/asset/nativeAddressHelper';
import { convertBasicTokenInfoToCovalentBalanceItem, getBasicTokenInfo } from '../pricing/useBasicTokenInfo';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { stableCoins } from '@/components/explore/stableCoins';
export const adjustNativeTokenData = token => {
  var _a, _b, _c;
  const tokenData = token.token;
  if (tokenData.address.toLowerCase() == (NATIVE_ADDRESS === null || NATIVE_ADDRESS === void 0 ? void 0 : NATIVE_ADDRESS.toLowerCase()) || tokenData.address.toLowerCase() === ((_a = WrappedNativeTokens.get(tokenData.networkId)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || tokenData.address.toLowerCase() == ZERO_ADDRESS || tokenData.address == WRAPPED_SOL || tokenData.address == NATIVE_SUI) {
    if (tokenData.networkId == ChainId.AVALANCHE) {
      tokenData.symbol = 'AVAX';
      tokenData.name = 'Avalanche';
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.AVALANCHE);
    } else if (tokenData.networkId == ChainId.BSC) {
      tokenData.symbol = 'BNB';
      tokenData.name = 'Binance Smart Chain';
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.BSC);
    } else if (tokenData.networkId == ChainId.POLYGON) {
      tokenData.symbol = 'POL';
      tokenData.name = 'Polygon';
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.POLYGON);
    } else if (tokenData.networkId == ChainId.SOLANA) {
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.SOLANA);
      tokenData.symbol = 'SOL';
      tokenData.name = 'SOLANA';
    } else if (tokenData.networkId == ChainId.SUI) {
      tokenData.symbol = 'SUI';
      tokenData.name = 'Sui';
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.SUI);
    } else {
      tokenData.symbol = 'ETH';
      tokenData.name = 'Ethereum';
      tokenData.info.imageThumbUrl = getNetworkLogo(ChainId.ETHEREUM);
    }
  }
  const sanitizedData = Object.assign(Object.assign({}, tokenData), {
    token: tokenData !== null && tokenData !== void 0 ? tokenData : null,
    tokenInfo: (_b = token.tokenInfo) !== null && _b !== void 0 ? _b : null,
    prices: (_c = token.prices) !== null && _c !== void 0 ? _c : null
  });
  return sanitizedData;
};
export const getTokenData = async (tokenAddress, tokenNetwork) => {
  try {
    const {
      address: tAddress
    } = transformAddress(tokenAddress, tokenNetwork);
    const data = await getBasicTokenInfo(parseInt(tokenNetwork), tAddress, true);
    return adjustNativeTokenData(data);
  } catch (error) {
    throw new Error(`_getTokenData:error:${error}`);
  }
};
const _getStableCoinsDataByNetwork = async tokenNetwork => {
  try {
    const _stableCoins = stableCoins.filter(_coin => {
      var _a;
      return (_a = _coin.networks) === null || _a === void 0 ? void 0 : _a.includes(tokenNetwork);
    }).map(_coin => ({
      name: _coin.name,
      address: _coin.tokens[tokenNetwork],
      network: tokenNetwork
    }));
    const _data = await Promise.all(_stableCoins.map(async token => {
      var _a, _b;
      const image = `/static/tokenlogos/${token.name}.png`;
      const _data = await getTokenData(token.address, (_a = token.network) === null || _a === void 0 ? void 0 : _a.toString());
      _data.token.info.imageThumbUrl = image;
      _data.token.info.imageSmallUrl = image;
      _data.token.info.imageLargeUrl = image;
      const _params = {
        token: _data === null || _data === void 0 ? void 0 : _data.token,
        tokenInfo: (_b = _data === null || _data === void 0 ? void 0 : _data.tokenInfo) === null || _b === void 0 ? void 0 : _b.results,
        prices: [_data === null || _data === void 0 ? void 0 : _data.prices]
      };
      const _convertedAsset = convertBasicTokenInfoToCovalentBalanceItem(_params);
      return _convertedAsset;
    }));
    return _data;
  } catch (error) {
    throw new Error(`_getStableCoinsDataByNetwork:error:${error}`);
  }
};
export const useStableCoinsData = tokenNetwork => {
  return useQuery({
    queryKey: ['stableCoinsQuery', tokenNetwork],
    queryFn: () => _getStableCoinsDataByNetwork(tokenNetwork),
    enabled: Boolean(tokenNetwork)
  });
};
export const useTokenData = ({
  tokenAddress,
  tokenNetwork,
  refetchInterval = 5000,
  staleTime = 4000,
  enabled = true
}) => {
  return useQuery({
    queryKey: ['tokenData', tokenAddress, tokenNetwork],
    queryFn: () => getTokenData(tokenAddress, tokenNetwork),
    enabled: Boolean(tokenAddress && tokenNetwork) && enabled,
    refetchInterval,
    staleTime
  });
};